<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="关键字搜索(姓名、证件号码)"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in REGIONAL_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in REGIONAL_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.countryId"
        placeholder="国家"
        style="width: 120px"
        class="filter-item"
        clearable
        @change="event => countryChange(event, 'listQueryCountry')"
      >
        <el-option
          v-for="item in listQueryCountry"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.provinceId"
        placeholder="省份"
        style="width: 120px"
        class="filter-item"
        clearable
        @change="event => provinceChange(event, 'listQueryProvinceOption')"
      >
        <el-option
          v-for="item in listQueryProvinceOption"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.cityId"
        placeholder="城市"
        style="width: 120px"
        class="filter-item"
        clearable
        @change="event => cityChange(event, 'listQueryCityOption')"
      >
        <el-option
          v-for="item in listQueryCityOption"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.areaId"
        placeholder="区域"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in listQueryAreaOption"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true)"
        >新增</el-button
      >
    </div>
    <div style="margin-bottom: 5px">区域代表数量:{{ total }}</div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="用户姓名"
        align="center"
        prop="userName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="用户手机号码"
        align="center"
        prop="userMobile"
        width="100"
      ></el-table-column>
      <el-table-column label="类型" align="center" prop="type" width="100">
        <template slot-scope="scope">
          <el-tag>{{ getValue(REGIONAL_TYPE, scope.row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="区域"
        align="center"
        prop="regionName"
        width="100"
      ></el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag>{{ getValue(REGIONAL_STATUS, scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="生效时间"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.activateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="取消时间"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.cancelTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="180"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="220"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="checkStatus(scope.row, 1)"
            class="comm_but_warp"
            v-if="[0,2].includes(scope.row.status)"
            >生效</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="checkStatus(scope.row, 2)"
            class="comm_but_warp"
            v-if="[0,1].includes(scope.row.status)"
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    新增区域代理-->
    <el-dialog
      title="新增区域代理"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="checkDialogFormVisible(false)"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="用户" prop="userId">
          <el-select
            v-model="form.userId"
            placeholder="关键字搜索(账号、姓名)"
            style="width: 100%"
            class="filter-item"
            clearable
            filterable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
            :loading="userLoading"
          >
            <el-option
              v-for="item in userOption"
              :key="item.id"
              :label="item.mobile"
              :value="item.id"
            >
              <span style="float: left">{{ item.mobile }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.gradeName
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
            @change="typeChange"
          >
            <el-option
              v-for="item in REGIONAL_TYPE"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="国家" prop="countryId">
          <el-select
            v-model="form.countryId"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
            @change="event => countryChange(event, 'countryOption')"
          >
            <el-option
              v-for="item in countryOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="省份" prop="provinceId">
          <el-select
            v-model="form.provinceId"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
            @change="event => provinceChange(event, 'provinceOption')"
          >
            <el-option
              v-for="item in provinceOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="城市"
          prop="cityId"
          v-if="[2, 3].includes(form.type)"
        >
          <el-select
            v-model="form.cityId"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
            @change="event => cityChange(event, 'cityOption')"
          >
            <el-option
              v-for="item in cityOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="areaId" v-if="[3].includes(form.type)">
          <el-select
            v-model="form.areaId"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in areaOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false)">取消</el-button>
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRegionalList, addRegional, editRegionalStatus,getMemberList } from "@/api/member";
import { getCascadeRegion } from "@/api/regional";
import { formatApiDate } from "@/utils/utils";
import { getValue, REGIONAL_STATUS, REGIONAL_TYPE } from "@/utils/enumUtile";
import { getBackGroundUserList } from "@/api/user";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    REGIONAL_TYPE() {
      return REGIONAL_TYPE;
    },
    REGIONAL_STATUS() {
      return REGIONAL_STATUS;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        type: null,
        status: null,
        countryId: null,
        provinceId: null,
        cityId: null,
        areaId: null
      },
      dialogFormVisible: false, // 新增会员
      rules: {
        userId: [
          { required: true, message: "用户不能为空", trigger: "change" }
        ],
        type: [{ required: true, message: "类型不能为空", trigger: "change" }],
        provinceId: [
          { required: true, message: "省份不能为空", trigger: "change" }
        ]
      },
      form: {
        userId: null, //用户
        type: null, // 类型
        countryId: null, // 国家
        provinceId: null, // 省份
        cityId: null, // 城市
        areaId: null // 区域
      },
      btnLoading: false,
      listQueryCountry: [], // 国家
      listQueryProvinceOption: [], // 省
      listQueryCityOption: [], // 市
      listQueryAreaOption: [], // 区
      countryOption: [], // 国家
      provinceOption: [], // 省
      cityOption: [], // 市
      areaOption: [], // 区
      userOption: [], // 用户选项
      userLoading: false
    };
  },
  created() {
    this.getList();
    this.getCascadeRegion(0).then(resp => {
      this.listQueryCountry = resp;
    });
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询用户
     * @param query
     */
    remoteMethod(query) {
      if (query !== "") {
        this.userLoading = true;
        const params = {
          keyword: query,
          page: 1,
          pageSize: 99,
          status: 0
        };
        // page: 1,
        //     pageSize: 20,
        //     keyword: null,
        //     userId: null,
        //     gradeId: null,
        //     status: null,
        //     certStatus: null
        getMemberList(params)
          .then(resp => {
            let data = [];
            if (resp && resp.bizcode === 100) {
              data = resp.data.entitys;
            }
            this.userOption = data;
          })
          .finally(() => {
            this.userLoading = false;
          });
      } else {
        this.userOption = [];
      }
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      delete params.countryId;
      getRegionalList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 类型切换
     * @param type
     */
    typeChange(type) {
      // 省
      if (type === 1) {
        this.form.cityId = null; // 城市
        this.form.areaId = null; // 区域
      } else if (type === 2) {
        // 市
        this.form.areaId = null; // 区域
      }
    },
    /**
     * 查询地区
     * @param pid
     */
    async getCascadeRegion(pid) {
      const params = {
        parentId: pid
      };
      const resp = await getCascadeRegion(params);
      let data = [];
      if (resp && resp.bizcode === 100) {
        data = resp.data;
      }
      return data;
    },
    /**
     * 国家切换
     */
    async countryChange(id, key) {
      if (key === "listQueryCountry") {
        this.listQueryProvinceOption = []; // 市
        this.listQueryCityOption = []; // 市
        this.listQueryAreaOption = []; // 区
        this.listQuery.provinceId = null; // 省份
        this.listQuery.cityId = null; // 城市
        this.listQuery.areaId = null; // 区域
        this.listQueryProvinceOption = await this.getCascadeRegion(id);
      } else if (key === "countryOption") {
        this.provinceOption = []; // 市
        this.cityOption = []; // 市
        this.areaOption = []; // 区
        this.form.provinceId = null; // 省份
        this.form.cityId = null; // 城市
        this.form.areaId = null; // 区域
        this.provinceOption = await this.getCascadeRegion(id);
      }
    },
    /**
     * 省切换
     */
    async provinceChange(id, type) {
      if (type === "listQueryProvinceOption") {
        this.listQueryCityOption = []; // 市
        this.listQueryAreaOption = []; // 区
        this.listQuery.cityId = null; // 城市
        this.listQuery.areaId = null; // 区域
        this.listQueryCityOption = await this.getCascadeRegion(id);
      } else if (type === "provinceOption") {
        this.cityOption = []; // 市
        this.areaOption = []; // 区
        this.form.cityId = null; // 城市
        this.form.areaId = null; // 区域
        this.cityOption = await this.getCascadeRegion(id);
      }
    },
    /**
     * 市切换
     */
    async cityChange(id, type) {
      if (type === "listQueryCityOption") {
        this.listQueryAreaOption = await this.getCascadeRegion(id);
      } else if (type === "cityOption") {
        this.areaOption = await this.getCascadeRegion(id);
      }
    },
    /**
     * 切换状态
     */
    async checkStatus(row, type) {
      let deleteGoodsMsg = "";
      if (type === 1) {
        // 生效
        deleteGoodsMsg = "确认要将改代理改为生效？";
      } else if (type === 2) {
        // 取消
        deleteGoodsMsg = "确认要将改代理改为取消？";
      }
      this.$confirm(deleteGoodsMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const params = {
          id: row.id,
          status: type
        };
        editRegionalStatus(params).then(resp => {
          if (resp && resp.bizcode === 100) {
            this.getList();
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success",
              duration: 2000
            });
          }
        });
      });
    },

    async checkDialogFormVisible(status) {
      if (!status) {
        this.countryOption = []; // 国家
        this.provinceOption = []; // 省
        this.cityOption = []; // 市
        this.areaOption = []; // 区
        this.form = {
          id: 0,
          userId: null, //用户
          type: null, // 类型
          countryId: null, // 国家
          provinceId: null, // 省份
          cityId: null, // 城市
          areaId: null // 区域
        };
        this.$refs.form.resetFields();
      } else {
        this.countryOption = await this.getCascadeRegion(0);
      }
      this.dialogFormVisible = status;
    },

    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = this.form;
          // delete params.countryId;
          this.btnLoading = true;
          addRegional(params)
            .then(resp => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkDialogFormVisible(false);
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
